<script>
  import { onMount } from 'svelte'
  import { getLocal } from '../stores/store'
  import Weather from './cards/Weather.svelte'
  import News from './cards/News.svelte'
  import Quote from './cards/Quote.svelte'
  import Pomodoro from './cards/Pomodoro.svelte'
  import Todo from './cards/Todo.svelte'

  const API_KEY = process.env.API_KEY
  const WEATHER_KEY = process.env.WEATHER_KEY
  const GOOGLE_KEY = process.env.GOOGLE_KEY

  let card = 'todo'
  let articles = []
  let quotes = []
  let weather = []
  let gettingQuote = false
  let idx = 0
  let coords = 0
  let latitude = 0
  let longitude = 0
  let zip
  let city = getLocal('city') || ''

  async function getRandomQuote() {
    card = 'quote'
    gettingQuote = true
    const res = await fetch('https://api.quotable.io/random')
    const json = await res.json()
    quotes = [json]
    gettingQuote = false
  }

  async function getNews() {
    const url = `https://newsapi.org/v2/top-headlines?country=us&apiKey=${API_KEY}`
    const headers = {
      method: 'GET'
    }
    card = 'news'
    idx++
    if (idx === 20) idx = 0
    await fetch(url, headers)
      .then(res => res.json())
      .then(data => (articles = [data.articles]))
      .catch(err => console.log(err))
  }

  async function getCoords(e) {
    zip = e.detail.zip
    await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${zip}&key=${GOOGLE_KEY}`
    )
      .then(res => res.json())
      .then(data => {
        coords = [data]
        console.log(coords)
        city = coords[0].results[0].address_components[1].long_name
        latitude = coords[0].results[0].geometry.location.lat
        longitude = coords[0].results[0].geometry.location.lng
        localStorage.setItem('city', JSON.stringify(city))
        localStorage.setItem('latitude', JSON.stringify(latitude))
        localStorage.setItem('longitude', JSON.stringify(longitude))
      })
      .catch(err => console.log(err))

    getWeather()
  }

  async function getWeather() {
    card = 'weather'
    latitude = getLocal('latitude')
    longitude = getLocal('longitude')
    await fetch(
      `https://api.weatherapi.com/v1/forecast.json?key=${WEATHER_KEY}&q=${latitude},${longitude}`
    )
      .then(res => res.json())
      .then(data => (weather = [data]))
      .catch(err => console.log(err))
  }
</script>

<style>
  .wrapper {
    display: grid;
    height: 100%;
    width: 100vw;
    justify-content: center;
    justify-items: center;
    align-items: center;
  }

  .cards {
    display: grid;
    grid-gap: 1em;
    height: 70vh;
    align-content: center;
  }

  h1 {
    filter: drop-shadow(-5px 5px 5px rgba(0, 0, 0, 0.5));
  }

  .links {
    display: flex;
    justify-content: center;
    font-size: 2.5vh;
    align-self: flex-end;
  }

  .active {
    opacity: 1;
  }

  button {
    outline: none;
    background-color: transparent;
    color: white;
    opacity: 0.5;
    border: none;
    padding: 0 2vw;
    font-size: 3vh;
  }

  button:hover {
    background: transparent;
    opacity: 0.9;
    cursor: pointer;
  }

  button:active {
    background: transparent;
  }

  @media only screen and (max-width: 800px) {
    button {
      padding: 0 1vw;
    }
  }
</style>

<div class="wrapper">
  {#if card === 'todo'}
    <div class="cards">
      <Todo />
    </div>
  {:else if card === 'pomodoro'}
    <div class="cards">
      <h1 style="text-align: center;">Pomodoro Timers</h1>
      <Pomodoro />
    </div>
  {:else if card === 'quote'}
    <div class="cards">
      <Quote {quotes} {gettingQuote} />
    </div>
  {:else if card === 'news'}
    <div class="cards">
      <h1 style="text-align: center;">News</h1>
      <News {articles} {idx} />
    </div>
  {:else if card === 'weather'}
    <div class="cards">
      <h1 style="text-align: center;">Weather</h1>
      <Weather {weather} {city} on:search={getCoords} on:display={getWeather} />
    </div>
  {/if}

  <div class="links">
    <button
      class={card === 'todo' ? 'active' : ''}
      on:click={() => (card = 'todo')}>
      Todo
    </button>
    <button
      class={card === 'pomodoro' ? 'active' : ''}
      on:click={() => (card = 'pomodoro')}>
      Pomodoro
    </button>
    <button class={card === 'quote' ? 'active' : ''} on:click={getRandomQuote}>
      Quote
    </button>
    <button class={card === 'news' ? 'active' : ''} on:click={getNews}>
      News
    </button>
    <button class={card === 'weather' ? 'active' : ''} on:click={getWeather}>
      Weather
    </button>
  </div>
</div>
